import { Route } from '@angular/router';
import { DeleteConfirmComponent } from './delete-confirm.component';

export const DeleteConfirmRoutes: Route[] = [
  {
    path: 'account/delete-confirm',
    component: DeleteConfirmComponent
  }
];
